import Chip from './Chip';
export default Chip;



// WEBPACK FOOTER //
// ./src/js/Chips/index.js